var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"image-box"},[(!_vm.hasLoadError)?_c('img',_vm._b({on:{"error":_vm.handleError}},'img',_vm.$attrs,false)):_c('img',_vm._b({attrs:{"src":_vm.defaultImg}},'img',_vm.$attrs,false))])}
var staticRenderFns = []

export { render, staticRenderFns }